export default "__VITE_ASSET__DxHfhSZi__"